/*       */
import React, { memo } from 'react';
import { Typography, Tooltip } from '@mic3/platform-ui';
import styled from 'styled-components';

import Link from 'app/components/atoms/Link/Link';
import { getRouteLink } from '../dashboardUtils';

const LinkStyled = styled(Link)`
    text-decoration: none !important;
`;

const ListItemWrapper = styled.div`
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    &:hover {
        background-color: ${({ theme }) => theme.material.colors.background.hover} !important;
    }
    cursor: pointer !important;
    color: #ffffffb3;
    padding: 14px 14px 14px 18px;
    gap: 1rem !important;
`;

const TypographyStyled = styled(Typography)`
    word-wrap: break-word;
    overflow-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: ${({ theme }) => theme.material.colors.text.primary} !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 20px !important;
    letter-spacing: 0.25px !important;
`;
const AdditionalInfoContainer = styled.div`
    flex-shrink: 0;
    white-space: nowrap;
    color: ${({ theme }) => theme.material.colors.text.secondary};
    display: flex !important;
    justify-content: end !important;
    & .MuiTypography-root {
        font-size: 12px !important;
        font-weight: 400 !important;
        line-height: 16px !important;
        letter-spacing: 0.4px !important;
        text-align: right;
    }
`;

const LinkList = ({ list, type: linkPath, renderAdditionalInfo }) =>
    (list || []).map((itemProps) => {
        const { id, name, type } = itemProps;
        return (
            <LinkStyled key={id} to={getRouteLink(type, id)}>
                <Tooltip title={name}>
                    <ListItemWrapper>
                        <TypographyStyled>{name || 'No Name'}</TypographyStyled>
                        {renderAdditionalInfo && (
                            <AdditionalInfoContainer>
                                {renderAdditionalInfo(itemProps)}
                            </AdditionalInfoContainer>
                        )}
                    </ListItemWrapper>
                </Tooltip>
            </LinkStyled>
        );
    });

export default memo(LinkList);
